import * as React from "react";

const VueIcon = ({
  fill = "black",
  width = "600px",
  height = "600px",
  rotation = "0",
}) => (
  <svg
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    width={width}
    height={height}
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <polygon
      fill={`${fill}66`}
      points="23.987,17 18.734,8 2.974,8 23.987,44 45,8 29.24,8"
    ></polygon>
    <polygon
      fill={`${fill}33`}
      points="29.24,8 23.987,17 18.734,8 11.146,8 23.987,30 36.828,8"
    ></polygon>
  </svg>
);

export default VueIcon;
